import { Button, Typography } from '@mui/material'
import notFound from '../../assets/img/404Logo.svg'
import { useNavigate } from 'react-router-dom'
import { URLAPP } from '../../config/contants.config'

interface NotFoundProps {
    label?: string
}

export default function Error404({ label = "No encontramos lo que buscabas..." }: NotFoundProps) {
    const navigate = useNavigate()
    return (
        <div className='notfound'>
            <Typography variant='h4' sx={{ marginTop: 'auto', textAlign: 'center' }}>{label}</Typography>
            <img src={notFound} alt="Not found" className='notfound-logo' />
            <Button size='large' onClick={() => navigate(URLAPP.start)}>Ir a inicio</Button>
        </div>
    )
}
